var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavigationSectionHeaderVar = void 0;

var react_1 = __importDefault(require("react"));

var core_1 = require("@wheelroom/core");

var navigation_header_1 = require("./header/navigation-header");

exports.NavigationSectionHeaderVar = function (props) {
  var sectionWheel = core_1.getSectionWheel({
    themeId: props.activeThemeId,
    wheelId: 'navigationSection',
    sectionWheels: props.sectionWheels,
    variation: 'header'
  });

  if (!sectionWheel) {
    return null;
  }

  var data = sectionWheel.data,
      wheel = sectionWheel.wheel;
  return react_1.default.createElement(navigation_header_1.NavigationHeader, {
    containerStyle: "container",
    data: data,
    defaultThemeId: props.sectionWheels.defaultThemeId,
    globals: props.globals,
    navigation: props.navigation || [],
    themes: props.sectionWheels.themes,
    wheel: wheel
  });
};